export default "__VITE_ASSET__yhsslAqa__";